import { render, staticRenderFns } from "./ModelesManager.vue?vue&type=template&id=30631c5a"
import script from "./ModelesManager.vue?vue&type=script&lang=js"
export * from "./ModelesManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports